export var toCamelCase = function toCamelCase(str) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';
  var strs = str.split(separator);
  return strs.map(function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLocaleLowerCase();
  }).join(separator);
};
export var getPaddedNumber = function getPaddedNumber(num) {
  if (num <= 9) {
    return "0".concat(num);
  }
  return "".concat(num);
};
export var populateStringTemplate = function populateStringTemplate(str, values) {
  var newString = str || '';
  Object.keys(values).forEach(function (key) {
    newString = newString.replace("$".concat(key), values[key]);
  });
  return newString;
};